/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Emailtemplate_Savesuccess3Inputs */

const en_coinvestments_emailtemplate_savesuccess3 = /** @type {(inputs: Coinvestments_Emailtemplate_Savesuccess3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email template saved`)
};

/**
* | output |
* | --- |
* | "Email template saved" |
*
* @param {Coinvestments_Emailtemplate_Savesuccess3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_emailtemplate_savesuccess3 = /** @type {((inputs?: Coinvestments_Emailtemplate_Savesuccess3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Emailtemplate_Savesuccess3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_emailtemplate_savesuccess3(inputs)
});
export { coinvestments_emailtemplate_savesuccess3 as "coInvestments_emailTemplate_saveSuccess" }